import type { LoaderFunctionArgs } from '~/types/route-args';

import { handle as infoHandle } from '@modules/professional/page/InfoPage';
import { loader as infoLoader } from '@modules/professional/api/info-page-loader.server';
import { loader as overviewLoader } from '@modules/professional/page/loaders/overview-page-loader.server';
import { isProfessionalRevampActive } from '@modules/professional/util/is-professional-revamp-active.server';
import InfoPage from '@modules/professional/page/info/InfoPage';
import { ProfessionalAboutPageRevamp } from '~/ui-rocco/pages/professional-detail/ProfessionalAboutPageRevamp';
import { inheritMeta } from '~/modules/seo';
import type { APHandle } from '~/modules/root';
import { useShowProfessionalRevamp } from '@modules/professional/hook/use-professional-layout-data';
import { shouldRevalidateLeaf } from '~/modules/root/util/should-revalidate-leaf';

/**
 * When the revamp is active the About tab becomes a full editorial page driven
 * by the overview loader (the reused hero/team/contact/closing sections read
 * it, and it already returns the custom library tabs for the accordion).
 * Otherwise it serves the legacy info page.
 */
export const loader = async (args: LoaderFunctionArgs) => {
    if (isProfessionalRevampActive(args.context, args.request)) {
        // The team, custom tabs and company images are the only extras it draws.
        return overviewLoader(args, ['info']);
    }
    return infoLoader(args);
};

export { inheritMeta as meta };

export const shouldRevalidate = shouldRevalidateLeaf;

export const handle: APHandle = {
    ...infoHandle,
    professionalRevampLayout: true,
};

const ProfessionalInfoRoute = () => {
    const showRevamp = useShowProfessionalRevamp();

    return showRevamp ? <ProfessionalAboutPageRevamp /> : <InfoPage />;
};

export default ProfessionalInfoRoute;
